import { render, staticRenderFns } from "./PurchaseInvestment.vue?vue&type=template&id=39ec7f1d"
import script from "./PurchaseInvestment.vue?vue&type=script&lang=js"
export * from "./PurchaseInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports